import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLHeadingElement>["className"];
  color?: TextColorType;
  id?: HTMLAttributes<HTMLHeadingElement>["id"];
  lineHeight?: number;
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Heading4({
  className,
  children,
  color,
  id,
  lineHeight,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize: "var(--font-size-heading-4)",
    fontWeight: 500,
    lineHeight: lineHeight || "var(--line-height-heading)",
    textAlign: textAlign || "start",
  };

  return (
    <h4 className={className} id={id} style={styles}>
      {children}
    </h4>
  );
}
